module.exports = __webpack_public_path__ + "static/media/duck.301b9849.svg";